import React from "react";
import { AppleFilled, AndroidFilled } from "@ant-design/icons";
import { Row, Col, Button, QRCode } from "antd";
import { useTranslation } from "react-i18next";

import {
  StyledMobileApp,
  GradientBlob1,
  GradientBlob2,
  ContentContainer,
  SectionTitle,
  SectionSubtitle,
  ButtonGroup,
  QRCodeCard,
  QRCodeLabel,
} from "./MobileApp.styles";
import { SectionContentWrapper } from "../../styled";

export const MobileApp: React.FC = () => {
  const { t } = useTranslation();

  return (
    <StyledMobileApp>
      <GradientBlob1 />
      <GradientBlob2 />
      <SectionContentWrapper>
        <ContentContainer>
          <Row gutter={[48, 48]} align="middle">
            <Col xs={24} lg={14}>
              <div>
                <SectionTitle>{t("home.mobileApp.title")}</SectionTitle>
                <SectionSubtitle>{t("home.mobileApp.subtitle")}</SectionSubtitle>
              </div>

              <ButtonGroup>
                <Button
                  size="large"
                  style={{
                    height: 56,
                    paddingInline: 24,
                    background: "rgba(255, 255, 255, 0.95)",
                    borderColor: "transparent",
                    color: "#6366f1",
                    fontWeight: 600,
                    fontSize: 15,
                    borderRadius: 16,
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <AppleFilled style={{ fontSize: 20 }} />
                  {t("home.mobileApp.appStore")}
                </Button>
                <Button
                  size="large"
                  style={{
                    height: 56,
                    paddingInline: 24,
                    background: "rgba(255, 255, 255, 0.95)",
                    borderColor: "transparent",
                    color: "#6366f1",
                    fontWeight: 600,
                    fontSize: 15,
                    borderRadius: 16,
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <AndroidFilled style={{ fontSize: 20 }} />
                  {t("home.mobileApp.googlePlay")}
                </Button>
              </ButtonGroup>
            </Col>

            <Col xs={24} lg={10}>
              <QRCodeCard>
                <QRCode type="svg" value="https://ant.design/" size={180} bordered={false} />
                <QRCodeLabel>{t("home.mobileApp.scanToDownload")}</QRCodeLabel>
              </QRCodeCard>
            </Col>
          </Row>
        </ContentContainer>
      </SectionContentWrapper>
    </StyledMobileApp>
  );
};
